/* Progressive enhancement: native details stay usable without JavaScript. */
(() => {
  'use strict';
  if (window.sdProductFaqReady) return;
  window.sdProductFaqReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    root.querySelectorAll('.sd-product-faq details:not([data-sd-faq-enhanced])').forEach((item, index) => {
      const summary = item.querySelector('summary');
      const panel = item.querySelector(':scope > .rte');
      if (!summary || !panel) return;
      const prefix = item.closest('section')?.id || 'sd-product-faq';
      summary.id ||= `${prefix}-question-${index}`;
      panel.id ||= `${prefix}-answer-${index}`;
      summary.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', summary.id);
      item.dataset.sdFaqEnhanced = '';
      const state = { expanded: item.open, animation: null, fade: null };
      function semantics() {
        item.dataset.sdExpanded = String(state.expanded);
        summary.setAttribute('aria-expanded', String(state.expanded));
        panel.setAttribute('aria-hidden', String(!state.expanded));
        panel.inert = !state.expanded;
      }
      function settle() {
        if (state.animation) {
          state.animation.onfinish = null;
          state.animation.cancel();
        }
        state.fade?.cancel();
        state.animation = state.fade = null;
        item.open = state.expanded;
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');
        delete item.dataset.sdAnimating;
        semantics();
      }
      semantics();
      summary.addEventListener('click', event => {
        // Keyboard Enter/Space generate the same native summary click.
        event.preventDefault();
        const start = item.getBoundingClientRect().height;
        const wasOpen = item.open;
        const opacity = wasOpen ? Number(getComputedStyle(panel).opacity) : 0;
        state.expanded = !state.expanded;
        semantics();
        if (reducedMotion.matches || typeof item.animate !== 'function') {
          settle();
          return;
        }
        if (state.animation) {
          state.animation.onfinish = null;
          state.animation.cancel();
        }
        state.fade?.cancel();
        item.style.height = `${start}px`;
        item.style.overflow = 'hidden';
        item.open = true;
        const style = getComputedStyle(item);
        const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const end = summary.getBoundingClientRect().height + border + (state.expanded ? panel.getBoundingClientRect().height : 0);
        item.dataset.sdAnimating = '';
        const animation = item.animate([{ height: `${start}px` }, { height: `${end}px` }], {
          duration: 460, easing: 'cubic-bezier(.22,.75,.25,1)', fill: 'forwards'
        });
        state.animation = animation;
        state.fade = panel.animate([{ opacity }, { opacity: state.expanded ? 1 : 0 }], {
          duration: 340, easing: 'ease', fill: 'forwards'
        });
        animation.onfinish = () => {
          if (state.animation === animation) settle();
        };
      });
      // Responsive reflow should settle to the current requested state, never clip text.
      window.addEventListener('resize', () => { if (state.animation) settle(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
